import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {CONVERSATION_CARD_HEIGHT, sidePanelConversationCard} from '../../../reportViewer/reportCommons';

/*
 * Props.
 */

interface ConversationDeniedCardProps {
  nbNonAccessible: number;
}

/*
 * Styles.
 */

const StyledConversationDeniedCardWrapper = styled.div`
  ${sidePanelConversationCard}

  display: flex;
  align-items: center;
  justify-content: center;

  height: ${CONVERSATION_CARD_HEIGHT}px;
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.semibold};
`;

const StyledIcon = styled(Icon)`
  margin-right: 15px;
`;

/**
 * Component.
 * @TODO Refactor when we have infinite scroll.
 * Then fetch next pages until a full page of accessible cards has been computed - or total is reach (then sum the total nb of non-accessible convos and display this).
 */

export const ConversationDeniedCard: FC<ConversationDeniedCardProps> = ({nbNonAccessible}) => (
  <StyledConversationDeniedCardWrapper>
    <StyledIcon name="warningFilledSmall" />
    <Plural
      id="analytics-side-panel-conversation-denied"
      value={nbNonAccessible}
      one="On this page, 1 conversation used to compute this metric has been moved to an inbox you do not have access to."
      other="On this page, # conversations used to compute this metric have been moved to inboxes you do not have access to."
    />
  </StyledConversationDeniedCardWrapper>
);
